<script>
import { FormModel } from '@/components/global/form';
import { scrollToError } from '../../utilities/helpers';

export default {
    name: 'CcBeneficiaryForm',

    props: {
        initialData: null,
    },

    data() {
        return {
            loading: false,
            model: null,
        };
    },

    computed: {
        isSelfPoliticallyVulnerable() {
            return this.model.$.vulnerable.find(item => item.type === 1);
        },
    },

    created() {
        this.model = new FormModel(this.initialData);
    },

    methods: {
        addBeneficiary() {
            this.model.$.beneficiaries.push({
                address_same_as_declared: null,
                title: '',
                tax_countries: [],
                sources: [],
                citizenship: 'Lietuva',
            });
        },

        removeBeneficiary(account) {
            this.model.$.beneficiaries = this.model.$.beneficiaries.filter(s => s !== account);
        },

        addBeneficiarySource(beneficiary) {
            beneficiary.sources.push({
                source: '',
            });
        },

        removeBeneficiarySource(beneficiary, source) {
            beneficiary.sources = beneficiary.sources.filter(s => s !== source);
        },

        addTaxCountry(beneficiary) {
            beneficiary.tax_countries.push({
                country_id: null,
                payer_code: '',
            });
        },

        removeTaxCountry(beneficiary, taxCountry) {
            beneficiary.tax_countries = beneficiary.tax_countries.filter(s => s !== taxCountry);
        },

        addVulnerable() {
            this.model.$.vulnerable.push({
                type: null,
                vulnerabilities: [],
            });
        },

        removeVulnerable(entry) {
            this.model.$.vulnerable = this.model.$.vulnerable.filter((vulnerable) => vulnerable !== entry);
        },

        vulnerabilityChange(relation) {
            if (relation.type === 1 || relation.type === '1') {
                return;
            }

            if (!relation.vulnerabilities.length) {
                return;
            }

            relation.vulnerabilities = relation.vulnerabilities.slice(relation.vulnerabilities.length - 1, relation.vulnerabilities.length);
        },

        typeChange(relation) {
            if (relation.type === 1 || relation.type === '1') {
                return;
            }

            relation.vulnerabilities = [];
        },

        async submit() {
            if (this.loading) {
                return;
            }
            this.loading = true;

            try {
                const response = await this.$http.post('', this.model.$);
                window.location = response.data.data.redirect;
            } catch (e) {
                this.model.$e.updateFromResponse(e);
                scrollToError();
                this.$sentyReporting.report(e);
            }

            this.loading = false;
        },
    },
};
</script>
